export function getPaymentStatusMessageForSessionId(state, sessionId) {
  if (state.triggerPayment.succeededSessions.includes(sessionId)) {
    return 'Thanks! We’ll let you know shortly if your payment was successful.';
  }
  if (state.triggerPayment.failedSessions.includes(sessionId)) {
    return 'There was a problem taking the payment. Please try again later.';
  }
  return null;
}
